import { setupWorker } from "msw/browser";

import { env } from "@/env";
import { createHandlers } from "@/mocks/handlers";

const worker = setupWorker(
  ...createHandlers({
    apiUrl: env.VITE_API_URL,
    shopifyDomain: env.VITE_SHOPIFY_DOMAIN,
    shopifyApiVersion: env.VITE_SHOPIFY_API_VERSION,
  }),
);

const getAppOrigins = () => {
  const appUrlOrigin = URL.canParse(env.VITE_APP_URL) ? new URL(env.VITE_APP_URL).origin : null;

  return new Set([window.location.origin, appUrlOrigin]);
};

export const startMockWorker = async () => {
  const appOrigins = getAppOrigins();

  await worker.start({
    serviceWorker: { url: "/mockServiceWorker.js" },
    onUnhandledRequest: (request, print) => {
      if (appOrigins.has(new URL(request.url).origin)) {
        return;
      }

      print.error();
    },
  });
};
